export default function AboutHero() {
  return (
    <section className="relative flex items-center bg-background">
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-primary/3 rounded-full blur-[80px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full py-24 lg:py-32">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <a 
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6 cursor-pointer"
            onClick={() => window.REACT_APP_NAVIGATE('/')}
          >
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </a>

          <div className="animate-fade-in-up">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary/10 border border-primary/20 text-primary rounded-full text-sm font-medium mb-6">
              About Us
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display text-foreground mb-6 leading-tight tracking-tight">
              We build systems<br />
              <span className="gradient-text">that think</span> for you.
            </h1>

            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl mx-auto">
              BreakThru AI is an automation consultancy obsessed with making service businesses run smarter, faster, and with less friction.
            </p>
          </div>

          <div className="relative animate-fade-in-up mt-12 w-full max-w-2xl">
            <div className="relative bg-card rounded-2xl p-8 lg:p-10 border border-border shadow-lg text-left">
              <img 
                src="https://breakthruai2.lovable.app/assets/logo-light-C_i0iZgi.png" 
                alt="BreakThru AI" 
                className="h-12 w-auto mb-6"
              />
              
              <p className="text-muted-foreground leading-relaxed">
                Founded with a simple belief: powerful automation shouldn't require an engineering team. We partner with businesses to design workflows that actually fit — no over-engineering, no unnecessary tools.
              </p>

              <div className="mt-6 flex gap-3">
                <div className="h-1 w-12 bg-primary rounded-full"></div>
                <div className="h-1 w-8 bg-primary/40 rounded-full"></div>
                <div className="h-1 w-4 bg-primary/20 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}